import * as actionTypes from "../action-types";

export const getHoroscope = payload => ({ type: actionTypes.GET_HOROSCOPE, payload });
export const setHoroscope = payload => ({ type: actionTypes.SET_HOROSCOPE, payload });

export const getAsthaKoota = payload => ({ type: actionTypes.GET_ASTHAKOOTA, payload });
export const setAsthaKoota = payload => ({ type: actionTypes.SET_ASTHAKOOTA, payload });

export const getAstroData = payload => ({ type: actionTypes.GET_ASTRO_DATA, payload });
export const setAstroData = payload => ({ type: actionTypes.SET_ASTRO_DATA, payload });